module.exports = __webpack_public_path__ + "img/People.ba85173f.jpg";